import React, { FC } from "react";
import {
  PictureInPicture as PictureInPictureIcon,
  PictureInPictureExit
} from "@yleisradio/yds-icons-react";

import { useEmbedParametersContext } from "../../contexts/EmbedParametersContext";
import i18n from "../../service/i18n";
import { Player } from "../../store/slices/mediaElementSlice";
import { usePlayerStore } from "../../store/usePlayerStore";

import { ControlBarButton } from "./ControlBarButton";

export const togglePictureInPicture = (
  player?: Player | HTMLVideoElement
): void => {
  if (document.pictureInPictureElement && document.exitPictureInPicture) {
    document.exitPictureInPicture();
  } else {
    player?.requestPictureInPicture?.();
  }
};

export const PictureInPicture: FC = () => {
  const { useStoreState } = usePlayerStore();
  const isCasting = useStoreState.isCasting();
  const isPictureInPicture = useStoreState.isPictureInPicture();
  const player = useStoreState.player();

  const { language } = useEmbedParametersContext();

  return !isCasting ? (
    <ControlBarButton
      aria-label={i18n("kuva_kuvassa_aria_label", { language })}
      onClick={() => togglePictureInPicture(player)}
      tooltip={i18n("kuva_kuvassa", { language })}>
      {isPictureInPicture ? <PictureInPictureExit /> : <PictureInPictureIcon />}
    </ControlBarButton>
  ) : null;
};
